import { number, string } from 'prop-types';
import React from 'react';
import { GoInfo } from 'react-icons/go';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';

import CurrencyFormat from '../../generic/CurrencyFormat';

export default function BudgetDetailsPopover({
  id,
  netClientBudget,
  netClientBudgetExternal,
  wkzBudget,
  coInvest,
  freeService,
  identifier,
}) {
  const budgetInfoId = `${identifier}-${id}-budget-details`;

  return (
    <>
      <GoInfo id={budgetInfoId} />
      <UncontrolledPopover target={budgetInfoId} trigger="hover">
        <PopoverBody>
          Net Client Budget:{' '}
          <CurrencyFormat
            name="netClientBudget"
            className="font-weight-semi-bold"
            value={netClientBudget}
            text
          />
          <br />
          Net Client Budget External:{' '}
          <CurrencyFormat
            name="netClientBudgetExternal"
            className="font-weight-semi-bold"
            value={netClientBudgetExternal}
            text
          />
          <br />
          Net Client Budget WKZ:{' '}
          <CurrencyFormat
            name="wkzBudget"
            className="font-weight-semi-bold"
            value={wkzBudget}
            text
          />
          <br />
          CoInvest:{' '}
          <CurrencyFormat
            name="coInvest"
            className="font-weight-semi-bold"
            value={coInvest}
            text
          />
          <br />
          Free Service:{' '}
          <CurrencyFormat
            name="freeService"
            className="font-weight-semi-bold"
            value={freeService}
            text
          />
        </PopoverBody>
      </UncontrolledPopover>
    </>
  );
}

BudgetDetailsPopover.propTypes = {
  id: number.isRequired,
  netClientBudget: number.isRequired,
  netClientBudgetExternal: number.isRequired,
  wkzBudget: number.isRequired,
  coInvest: number.isRequired,
  freeService: number.isRequired,
  identifier: string.isRequired,
};
